// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-q_fM","advertDetailServiceList__header":"c-q_fN","advertDetailServiceList__list":"c-q_fO"};